export const ICON_SIZE: `${number}em` = '1.4em'
